// extracted by mini-css-extract-plugin
export default {"c":"style_c__ruXaV","front":"style_front__r+02K","back":"style_back__ieFC4","container":"style_container__xLF4-"};